<template>
  <div class="small-12 medium-12 large-8 columns">
    <img :src="noticia.noticia_imagemsecundaria" 
      v-if="noticia.noticia_imagemsecundaria.length > 0">
    <div class="corpo_noticia">
      <p class="noticia_data2">
        {{ $t("UMA_LANG_DATAPUB") }}:
        {{ noticia.noticia_data_publicacao }}
      </p>
      <h2>{{ noticia.post_title }}</h2>
      <div class="icons_partilhar">
        <a target="_blank" v-if="noticia.noticia_twitter.length > 0" 
          :href="noticia.noticia_twitter">
          <i class="fa fa-twitter" aria-hidden="true"></i>
        </a>
        <a target="_blank" v-if="noticia.noticia_facebook.length > 0" 
          :href="noticia.noticia_facebook">
          <i class="fa fa-facebook" aria-hidden="true"></i>
        </a>
        <a target="_blank" v-if="noticia.noticia_linkedin.length > 0" 
          :href="noticia.noticia_linkedin">
          <i class="fa fa-linkedin" aria-hidden="true"></i>
        </a>
      </div>
      <div class="noticia_corpo2" v-html="noticia.noticia_corpo"></div>
    </div>
  </div>
</template>

<script>

export default {
  props:["noticia"],
  setup() {


    return {}
  }
}
</script>

<style lang="scss" scoped>
.corpo_noticia {
  font-family: "PT Sans";
}

.noticia_data2 {
  font-family: "PT Sans Italic";
  font-size: 15px;
  color: #c0bfc9;
  margin-top: 45px;
}

.corpo_noticia h2 {
  font-family: "Montserrat Bold";
  font-size: 50px;
  color: #333333;
  padding-top: 10px;
}

.noticia_corpo2 {
  font-family: 'PT Sans';
  color: #333333;
  font-size: 16px;
  padding-right: 40px;
  padding-top: 10px;
  line-height: 2.25;
  margin-top: 40px;
}

@media (max-width: 767px) {
  .corpo_noticia h2 {
    font-size: 24px;
    color: #333333;
    padding-bottom: 10px;
  }

  .noticia_corpo2 {
    line-height: 2;
    font-size: 14px;
    padding-right: 0;
    margin-top: 0;
    padding-top: 0;
    font-family: 'PT Sans';
    color: #333333;
  }
}
</style>